export default __webpack_public_path__ + "cbe07bcd10a9917e8c59e21f23cc408d.png";